/*
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

type RtcToken = { userId: string; token: string };

const parseTokens = (raw: string | undefined): RtcToken[] => {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.every((t) => t && typeof t.userId === 'string' && typeof t.token === 'string')) {
      return parsed;
    }
    console.warn('[config] REACT_APP_RTC_TOKENS has invalid shape, ignoring.');
  } catch (err) {
    console.warn('[config] Failed to parse REACT_APP_RTC_TOKENS as JSON, ignoring.', err);
  }
  return [];
};

const parsePositiveInt = (raw: string | undefined, fallback: number): number => {
  if (!raw) return fallback;
  const n = Number(raw);
  if (!Number.isFinite(n) || n <= 0) {
    console.warn(`[config] Invalid numeric env "${raw}", falling back to ${fallback}.`);
    return fallback;
  }
  return Math.floor(n);
};

const config = {
  appId: process.env.REACT_APP_RTC_APP_ID || '',
  roomId: process.env.REACT_APP_RTC_ROOM_ID || '',
  tokenEndpoint: process.env.REACT_APP_RTC_TOKEN_ENDPOINT || '/api/token',
  tokens: parseTokens(process.env.REACT_APP_RTC_TOKENS),
  // "Are you still there?" attention prompt. Defaults: ask every 30s,
  // auto-end the meeting if the user does not respond within 10s.
  idlePromptIntervalMs: parsePositiveInt(process.env.REACT_APP_IDLE_PROMPT_INTERVAL_MS, 30_000),
  idlePromptTimeoutMs: parsePositiveInt(process.env.REACT_APP_IDLE_PROMPT_TIMEOUT_MS, 10_000),
};

export default config;
